import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map, switchMap } from 'rxjs/operators';
import { DirectPlan } from '../../models/direct-subscription.interface';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';
import {
  AdyenPayoutMethodStatus,
  PayoutMethod,
  PayoutMethodProvider,
  PayoutMethodsService,
} from '../../services/payout-methods.service';

@Component({
  standalone: false,
  templateUrl: './direct-payout-methods-list.component.html',
  styleUrls: ['./direct-payout-methods-list.component.scss'],
})
export class DirectPayoutMethodsComponent implements OnInit {
  PayoutMethodProvider = PayoutMethodProvider;
  AdyenPayoutMethodStatus = AdyenPayoutMethodStatus;

  directSubscription$ = this.directSubscription.subscriptionStatus$;

  isMobile$ = this.breakpointObserver.observe(['(max-width: 1279px)']).pipe(map((res) => res.matches));

  payoutMethods$ = this.directSubscription$.pipe(
    switchMap((subscription) => {
      return this.payoutMethodsService.fetchPayoutMethods(
        subscription.plan === DirectPlan.Premium ? PayoutMethodProvider.ADYEN : PayoutMethodProvider.STRIPE_OAUTH
      );
    })
  );

  constructor(
    private payoutMethodsService: PayoutMethodsService,
    private router: Router,
    private directSubscription: DirectSubscriptionService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit() { }

  addPaymentMethod(plan: DirectPlan) {
    if (plan === DirectPlan.Premium) {
      this.router.navigate(['/direct/payouts/new/adyen']);
    } else {
      this.router.navigate(['/direct/payouts/new/stripe-oauth']);
    }
  }

  updatePayoutMethod(payout) {
    this.router.navigate([`/direct/payouts/edit/${payout.uuid}`, { combined: true }]);
  }

  verifyClicked(uuid: string) {
    window.open(`/direct/payouts/verify/${uuid}`, '_blank');
  }

  addTaxInformation(uuid: string) {
    this.router.navigate([`/direct/payouts/add-tax-information/${uuid}`]);
  }

  deletePayoutMethodPrompt(payout: PayoutMethod) {
    if (!payout.can_delete || payout.all_properties) {
      const message = payout.all_properties
        ? 'You are not allowed to delete this payout method because it is assigned to all properties'
        : 'You are not allowed to delete this payout method';
      this.toast.open(message, 'Dismiss', NotificationType.Error);
      return;
    }

    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      data: {
        name: 'this Payout Method',
        identifier: payout.name,
        additionalText:
          payout.property_scope.length > 0
            ? `
          <p>This payout method is being used for bookings on <strong>${payout.property_scope.length} properties</strong>. If you delete it, you'll need to set another payout method on those properties to process bookings.</p>
        `
            : '',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deletePayoutMethod(payout.uuid);
      }
    });
  }

  deletePayoutMethod(uuid: string) {
    this.payoutMethodsService.deletePayoutMethod(uuid).subscribe((res) => {
      this.payoutMethods$ = this.directSubscription$.pipe(
        switchMap((subscription) => {
          return this.payoutMethodsService.fetchPayoutMethods(
            subscription.plan === DirectPlan.Premium ? PayoutMethodProvider.ADYEN : PayoutMethodProvider.STRIPE_OAUTH
          );
        })
      );
    });
  }
}
